import React from 'react';
import * as Sentry from '@sentry/react';

// Fallback UI shown when an error occurs
function ErrorFallback({ error, resetError }) {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      textAlign: 'center',
      backgroundColor: '#f8f9fa',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '32px',
        maxWidth: '400px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>😕</div>
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#333',
          marginBottom: '12px',
        }}>
          Something went wrong
        </h1>
        <p style={{
          fontSize: '16px',
          color: '#666',
          marginBottom: '24px',
          lineHeight: '1.5',
        }}>
          We're sorry for the inconvenience. Our team has been notified and is working on it.
        </p>
        <button
          onClick={resetError}
          style={{
            backgroundColor: '#2AACAD',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: '500',
            cursor: 'pointer',
            marginRight: '12px',
          }}
        >
          Try Again
        </button>
        <button
          onClick={() => window.location.reload()}
          style={{
            backgroundColor: 'transparent',
            color: '#2AACAD',
            border: '2px solid #2AACAD',
            borderRadius: '8px',
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: '500',
            cursor: 'pointer',
          }}
        >
          Reload Page
        </button>
        {process.env.NODE_ENV === 'development' && error && (
          <details style={{
            marginTop: '24px',
            textAlign: 'left',
            backgroundColor: '#f8f9fa',
            padding: '12px',
            borderRadius: '8px',
            fontSize: '12px',
          }}>
            <summary style={{ cursor: 'pointer', fontWeight: '500' }}>
              Error Details (dev only)
            </summary>
            <pre style={{
              marginTop: '8px',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              color: '#dc3545',
            }}>
              {error.toString()}
              {error.stack && `\n\n${error.stack}`}
            </pre>
          </details>
        )}
      </div>
    </div>
  );
}

// Sentry-integrated error boundary
export const SentryErrorBoundary = Sentry.withErrorBoundary(
  ({ children }) => children,
  {
    fallback: ({ error, resetError }) => (
      <ErrorFallback error={error} resetError={resetError} />
    ),
    showDialog: false, // Set to true to show Sentry's feedback dialog
  }
);

export default SentryErrorBoundary;
